// src/components/Card.js
import React from "react";
import "../../../src/style.css";
const BundlelivestockCard = ({ image, title, subtitle }) => {
  return (
    <div className="custom-card p-2" >
      <div className="row">
        <div className="col-12 d-flex justify-content-center">
          <img src={image} className="bundlecard-img text-center" alt={title} width='70%' />
        </div>
      </div>
      <div className="card-body">
      <div className="row">
        <div className="col-12">
            <p className="fw-bold text-center p-2 mt-2" style={{fontSize:'12px'}}>{title}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BundlelivestockCard;
